/**
 * Allowlist of hosts the widget is allowed to load images from.
 *
 * All such URLs originate from Google Places responses cached in CRUD forms
 * 492 / 494 (field Rows) and end up in an img src attribute. Rows is written
 * by the client, so its contents cannot be trusted
 * (Veracode static scan 20260804-sb-hpscoutso, flaws 43 / 44, CWE-80).
 *
 * The list is backed by an audit of both forms: stored data contains only
 * maps.gstatic.com, lh3-lh6.googleusercontent.com and lh3-lh6.ggpht.com.
 * googleapis.com and google.com are included pre-emptively: the former serves
 * place/photo, the latter hosted place icons in older Places responses.
 */
const SAFE_IMAGE_HOSTS = [
  'gstatic.com',
  'googleusercontent.com',
  'ggpht.com',
  'googleapis.com',
  'google.com',
]

/**
 * Returns the URL if it is safe to use as an <img src>, otherwise undefined.
 * Requirements: a well-formed absolute URL, https scheme, allowlisted host.
 */
export const safeImageUrl = (raw: unknown): string | undefined => {
  if (typeof raw !== 'string') {
    return undefined
  }
  try {
    const url = new URL(raw)
    if (url.protocol !== 'https:') {
      return undefined
    }
    const allowed = SAFE_IMAGE_HOSTS.some(
      (host) => url.hostname === host || url.hostname.endsWith(`.${host}`)
    )
    return allowed ? url.href : undefined
  } catch {
    return undefined
  }
}
